<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin-top: 20px;">Global admin setup</h1>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div v-if="!isCreated" class="container">
            <div class="alert alert-primary" role="alert">
                Global admin is the highest privilage role in TransparentChoice.
                Users in this role can manage organizations and other users.
                Please create one before you will create workspace and invite users.
                It is always good to have at least two users with that role to avoid an issue of single point of failure, so after setting up an instance you can nominate second one..
                After creating an admin will receive system generated password which should be changes to user provided one ASAP.
            </div>

            <div class="form-group">
                <label for="Email">Email:</label>
                <input v-model="email" type="email" class="form-control" placeholder="Work email of an admin">
                <ValidationError context="Email" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="FirstName">First name:</label>
                <input v-model="firstName" type="text" class="form-control" placeholder="First name of an admin">
                <ValidationError context="FirstName" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="LastName">Last name:</label>
                <input v-model="lastName" type="text" class="form-control" placeholder="Last name of an admin">
                <ValidationError context="LastName" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group form-check">
                <input v-model="setInitialPassword" type="checkbox" class="form-check-input" id="setInitialPassword">
                <label class="form-check-label" for="setInitialPassword">Set initial password manually</label>
            </div>

            <div v-show="setInitialPassword">
                <div class="form-group">
                    <label for="Password">Initial password:</label>
                    <input v-model="password" type="password" class="form-control">
                    <ValidationError context="Password" :errors="validationErrors"></ValidationError>
                </div>

                <div class="form-group" v-show="password">
                    <label for="PasswordConfirmation">Initial password confirmation:</label>
                    <input v-model="passwordConfirmation" type="password" class="form-control" :class="{ 'is-invalid': passwordConfirmationInvalid }">
                    <div class="invalid-feedback">Initial password confirmation doesn't match</div>
                </div>
            </div>

            <button v-if="!invokingCreateUserCommandV1" @click="handleCreateUserCommandV1" type="button" class="btn btn-primary btn-lg" :disabled="passwordConfirmationInvalid">Create</button>
            <button v-else type="button" class="btn btn-primary btn-lg" disabled>Creating...</button>
        </div>

        <div v-else class="container">
            <h1>Congratulations!</h1>
            <h3>Global admin account was created and password was sent on email {{email}}</h3>
            <a class="btn btn-primary btn-lg" href="/#/" role="button">Sign-in</a>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, computed, onMounted, watch } from 'vue'

    import ValidationError from '@common/Components/ValidationError.vue'
    import { useCreateUserCommandV1 } from '@Organizations/Users/commands-vue-composables'

    // ---------------- local state ----------------

    const email = ref('')
    const firstName = ref('')
    const lastName = ref('')
    const password = ref('')
    const passwordConfirmation = ref('')
    const setInitialPassword = ref(false)

    // ---------------- validation ----------------

    const passwordConfirmationInvalid = computed(() =>
    {
        if (!setInitialPassword.value) return false
        return !!passwordConfirmation.value && passwordConfirmation.value !== password.value
    })

    // ---------------- command ----------------

    const {
        invokeCreateUserCommandV1,
        invokingCreateUserCommandV1,
        validationErrors,
        succeedCreateUserCommandV1,
        errorCreateUserCommandV1
    } = useCreateUserCommandV1('0', null, email, firstName, lastName, true, false, false, false, setInitialPassword, password)

    const isCreated = computed(() => succeedCreateUserCommandV1.value === true)

    onMounted(() =>
    {
        document.title = 'Global admin setup'
    })

    // ---------------- handlers ----------------

    function handleCreateUserCommandV1()
    {
        if (passwordConfirmationInvalid.value) return
        invokeCreateUserCommandV1()
    }

    watch(errorCreateUserCommandV1, (err) =>
    {
        if (err)
        {
            alert(err)
        }
    })
</script>

